// This acts as a store away from Redux's own state tree.
// It can be used to store things that cannot be stored
// in Redux's state, such as functions, classes, and
// anything else that's not easily serializable to JSON.

// It simply attaches an empty object to the appConfig
// property of the global window object, which can then
// be imported and accessed from anywhere within the app.

import type UA from '../JsSIP/UserAgent';

interface AppConfig {
  extension?: UA;
}

const appConfig: AppConfig = {};

export default appConfig;
